// SPDX-License-Identifier: MIT
export const WORDLIST = [
    'abajur',
    'abaküs',
    'abartı',
    'abdal',
    'abdest',
    'abiye',
    'abluka',
    'abone',
    'absorbe',
    'absürt',
    'acayip',
    'acele',
    'acemi',
    'açıkgöz',
    'adalet',
    'adam',
    'adezyon',
    'adisyon',
    'adliye',
    'adres',
    'afacan',
    'afili',
    'afiş',
    'afiyet',
    'aforizm',
    'afra',
    'ağaç',
    'ağır',
    'ahbap',
    'ahkam',
    'ahlak',
    'ahtapot',
    'aidat',
    'aile',
    'ajan',
    'akademi',
    'akarsu',
    'akbaş',
    'akciğer',
    'akdeniz',
    'akıbet',
    'akıl',
    'akıntı',
    'akide',
    'akrep',
    'akrobasi',
    'aksiyon',
    'akşam',
    'aktif',
    'aktör',
    'aktris',
    'akustik',
    'alaca',
    'albüm',
    'alçak',
    'aldanma',
    'aleni',
    'alet',
    'alfabe',
    'algılama',
    'alıngan',
    'alkış',
    'alkol',
    'alpay',
    'alperen',
    'altın',
    'altüst',
    'altyapı',
    'alyuvar',
    'amade',
    'amatör',
    'amazon',
    'ambalaj',
    'amblem',
    'ambulans',
    'amca',
    'amel',
    'amigo',
    'amir',
    'amiyane',
    'amorti',
    'ampul',
    'anadolu',
    'anahtar',
    'anakonda',
    'anaokul',
    'anapara',
    'anarşi',
    'anatomi',
    'anayasa',
    'anekdot',
    'anestezi',
    'angaje',
    'anka',
    'anket',
    'anlamlı',
    'anne',
    'anomali',
    'anonim',
    'anten',
    'antlaşma',
    'apse',
    'araba',
    'aracı',
    'araf',
    'arbede',
    'arda',
    'arefe',
    'arena',
    'argo',
    'argüman',
    'arkadaş',
    'armoni',
    'aroma',
    'arsa',
    'arsız',
    'artı',
    'artist',
    'aruz',
    'asansör',
    'asayiş',
    'asfalt',
    'asgari',
    'asil',
    'asker',
    'askı',
    'aslan',
    'asosyal',
    'astsubay',
    'asya',
    'aşçı',
    'aşırı',
    'aşure',
    'atabey',
    'ataman',
    'ateş',
    'atmaca',
    'atmosfer',
    'atom',
    'atölye',
    'avcı',
    'avdet',
    'avize',
    'avlu',
    'avokado',
    'avrupa',
    'avukat',
    'ayaz',
    'ayçiçeği',
    'aydın',
    'aygıt',
    'ayna',
    'ayran',
    'ayrıntı',
    'azim',
    'baca',
    'bagaj',
    'bağlantı',
    'bahadır',
    'bahçe',
    'baki',
    'bakkal',
    'baklava',
    'bakteri',
    'balçık',
    'balina',
    'balo',
    'balta',
    'bant',
    'banyo',
    'bardak',
    'barış',
    'başbuğ',
    'başıboş',
    'başkan',
    'başlık',
    'bavul',
    'bayındır',
    'baykuş',
    'bazlama',
    'bedel',
    'begüm',
    'bekçi',
    'bekle',
    'belge',
    'belki',
    'bencil',
    'benek',
    'bengi',
    'benzer',
    'berjer',
    'berk',
    'bermuda',
    'berrak',
    'beşik',
    'beton',
    'beyin',
    'beyoğlu',
    'bıçak',
    'biberiye',
    'bidon',
    'biftek',
    'bihaber',
    'bikini',
    'bilezik',
    'bilinç',
    'bilye',
    'bina',
    'binbaşı',
    'binyıl',
    'bisiklet',
    'bisküvi',
    'bitki',
    'bizzat',
    'bodrum',
    'boğaz',
    'bohça',
    'bolero',
    'boncuk',
    'bonfile',
    'borsa',
    'boru',
    'bostan',
    'boşboğaz',
    'botanik',
    'boya',
    'boykot',
    'boynuz',
    'bozgun',
    'bozkır',
    'bölüm',
    'börek',
    'buçuk',
    'bugün',
    'buğday',
    'buhar',
    'buhran',
    'bulvar',
    'buram',
    'burçak',
    'burs',
    'burun',
    'butik',
    'buzdağı',
    'buzkıran',
    'bücür',
    'büfe',
    'bülten',
    'bütçe',
    'bütün',
    'büyük',
    'cacık',
    'cadı',
    'cahil',
    'cambaz',
    'canhıraş',
    'casus',
    'cazibe',
    'cehalet',
    'cehennem',
    'ceket',
    'cemre',
    'cenin',
    'cennet',
    'cepken',
    'cerrah',
    'cesur',
    'cetvel',
    'cevher',
    'ceylan',
    'cılız',
    'cıva',
    'cilt',
    'cisim',
    'ciyak',
    'coğrafya',
    'cömert',
    'cumba',
    'cüzdan',
    'çabucak',
    'çadır',
    'çağdaş',
    'çağlayan',
    'çağrı',
    'çakmak',
    'çalışkan',
    'çamaşır',
    'çapa',
    'çaput',
    'çarık',
    'çarpan',
    'çarşaf',
    'çayhane',
    'çekirdek',
    'çelebi',
    'çember',
    'çenet',
    'çengel',
    'çerçeve',
    'çerez',
    'çeşit',
    'çeşme',
    'çete',
    'çevre',
    'çeyiz',
    'çeyrek',
    'çığır',
    'çılgın',
    'çıngırak',
    'çift',
    'çiğdem',
    'çikolata',
    'çilek',
    'çimen',
    'çivi',
    'çoban',
    'çocuk',
    'çokgen',
    'çomak',
    'çorba',
    'çözelti',
    'çubuk',
    'çukur',
    'çuval',
    'çürük',
    'dağbaşı',
    'dağılım',
    'daktilo',
    'daldırış',
    'dalga',
    'dalkavuk',
    'damak',
    'damıtma',
    'damla',
    'dana',
    'dandik',
    'danışman',
    'daniska',
    'dantel',
    'dargeçit',
    'darphane',
    'davet',
    'dayı',
    'defter',
    'değer',
    'değirmen',
    'dehşet',
    'delgeç',
    'demir',
    'deneyim',
    'denge',
    'depo',
    'deprem',
    'derdest',
    'dere',
    'derhal',
    'derman',
    'dernek',
    'derviş',
    'desen',
    'destan',
    'dışarı',
    'dışbükey',
    'dijital',
    'dikbaşlı',
    'dilekçe',
    'dimağ',
    'dinamik',
    'dindar',
    'dinleme',
    'dinozor',
    'dipçik',
    'dipnot',
    'direniş',
    'dirsek',
    'disiplin',
    'disk',
    'divriği',
    'dizüstü',
    'dobra',
    'dodurga',
    'doğalgaz',
    'doktor',
    'doküman',
    'dolap',
    'donanım',
    'dondurma',
    'donör',
    'doruk',
    'dosdoğru',
    'dost',
    'dosya',
    'dozer',
    'döküm',
    'dönence',
    'dörtyol',
    'dövme',
    'dram',
    'dublaj',
    'durum',
    'duvak',
    'duyarga',
    'duyma',
    'duyuru',
    'düğme',
    'düğüm',
    'dükkan',
    'dünür',
    'düpedüz',
    'dürbün',
    'düşünür',
    'düzayak',
    'düzeltme',
    'ebeveyn',
    'ebru',
    'ecel',
    'ecnebi',
    'ecza',
    'edat',
    'edilgen',
    'efendi',
    'efor',
    'efsane',
    'egemen',
    'egzersiz',
    'eğrelti',
    'ekarte',
    'ekip',
    'eklem',
    'ekmek',
    'ekol',
    'ekonomi',
    'ekose',
    'ekran',
    'ekvator',
    'elaman',
    'elastik',
    'elbet',
    'elbise',
    'elçi',
    'eldiven',
    'elebaşı',
    'eleştiri',
    'elma',
    'eloğlu',
    'elveda',
    'emare',
    'emekçi',
    'emisyon',
    'emniyet',
    'empati',
    'emsal',
    'emzik',
    'endüstri',
    'enerji',
    'engebe',
    'engin',
    'enişte',
    'enkaz',
    'entari',
    'entegre',
    'entrika',
    'enzim',
    'erdem',
    'ergen',
    'erguvan',
    'erkek',
    'erozyon',
    'ertesi',
    'erzak',
    'esaret',
    'esenlik',
    'eser',
    'eski',
    'esnek',
    'eşarp',
    'eşofman',
    'eşraf',
    'eşya',
    'eşzaman',
    'etik',
    'etken',
    'etkinlik',
    'etüt',
    'evet',
    'evire',
    'evrak',
    'evrim',
    'eyalet',
    'eyvah',
    'ezber',
    'fabrika',
    'fanatik',
    'fanus',
    'fason',
    'fasulye',
    'fatih',
    'fatura',
    'fauna',
    'favori',
    'fayans',
    'fayton',
    'fazıl',
    'fazilet',
    'federal',
    'felsefe',
    'fener',
    'feribot',
    'fersah',
    'fesih',
    'festival',
    'feveran',
    'feza',
    'fıçı',
    'fıldır',
    'fındık',
    'fırça',
    'fırsat',
    'fırtına',
    'fıtık',
    'fidan',
    'fidye',
    'figür',
    'fihrist',
    'fikir',
    'fildişi',
    'filo',
    'filtre',
    'fincan',
    'firuze',
    'fitil',
    'fiyaka',
    'fizik',
    'flaş',
    'flüt',
    'fosil',
    'fren',
    'fukara',
    'futbol',
    'garabet',
    'gariban',
    'garnitür',
    'gazi',
    'gece',
    'gedik',
    'gelenek',
    'gelin',
    'gemi',
    'genç',
    'geniş',
    'geometri',
    'gerçek',
    'gevrek',
    'gezegen',
    'gezgin',
    'geziyolu',
    'gıcık',
    'gıda',
    'gıybet',
    'girdap',
    'girişim',
    'gitar',
    'giyecek',
    'giysi',
    'gizem',
    'gofret',
    'goril',
    'göbek',
    'göçebe',
    'göğüs',
    'gökdelen',
    'gökmen',
    'gökyüzü',
    'gölge',
    'gömlek',
    'gönül',
    'görenek',
    'görkemli',
    'görsel',
    'gösteri',
    'gövde',
    'gözaltı',
    'gözcü',
    'gözdağı',
    'gözleme',
    'gözyaşı',
    'grup',
    'gurbet',
    'gusül',
    'gübre',
    'güfte',
    'gümüş',
    'günaydın',
    'güncel',
    'gündüz',
    'güneş',
    'günyüzü',
    'gürbüz',
    'güvercin',
    'güzel',
    'haber',
    'hacamat',
    'hacim',
    'hademe',
    'hafız',
    'hafriyat',
    'hafta',
    'hakan',
    'hakem',
    'hakikat',
    'haksever',
    'halı',
    'hançer',
    'hane',
    'hangar',
    'hapis',
    'hapşırık',
    'harf',
    'haseki',
    'hasret',
    'hatun',
    'havuç',
    'haylaz',
    'haysiyet',
    'hayvan',
    'hedef',
    'hektar',
    'hemen',
    'hemfikir',
    'hendek',
    'hepsi',
    'hergele',
    'herhangi',
    'hesap',
    'heyecan',
    'heykel',
    'hezimet',
    'hıçkırık',
    'hızölçer',
    'hicviye',
    'hikaye',
    'hikmet',
    'hile',
    'hisse',
    'hobi',
    'hoca',
    'horlama',
    'hormon',
    'hoşbeş',
    'hoşgörü',
    'hoyrat',
    'hörgüç',
    'höyük',
    'hudut',
    'hukuk',
    'hunhar',
    'hurda',
    'huysuz',
    'huzur',
    'hücum',
    'hükümet',
    'hünkar',
    'hüviyet',
    'ırmak',
    'ısıölçer',
    'ısıtıcı',
    'ıspanak',
    'ısrar',
    'ışıldak',
    'ızdırap',
    'ızgara',
    'ibadet',
    'icat',
    'içbükey',
    'içecek',
    'içgüdü',
    'içsel',
    'idman',
    'iftihar',
    'iğne',
    'ihanet',
    'ihbar',
    'ihdas',
    'ihmal',
    'ihracat',
    'ihsan',
    'ikilem',
    'ikindi',
    'ikircik',
    'iklim',
    'iksir',
    'iktibas',
    'ilaç',
    'ilçe',
    'ileri',
    'iletişim',
    'ilgi',
    'ilhak',
    'ilkbahar',
    'ilkokul',
    'ilmek',
    'imkan',
    'imleç',
    'imsak',
    'imtihan',
    'imza',
    'ince',
    'inkar',
    'inşa',
    'ipek',
    'ipucu',
    'irade',
    'irfan',
    'irmik',
    'isabet',
    'iskele',
    'israf',
    'isyan',
    'işçi',
    'işgal',
    'işgüzar',
    'işlem',
    'itibar',
    'itiraf',
    'ivedi',
    'ivme',
    'iyileşme',
    'iyimser',
    'izbandut',
    'izci',
    'izdiham',
    'izin',
    'jakoben',
    'jandarma',
    'jargon',
    'kabadayı',
    'kablo',
    'kabus',
    'kaçamak',
    'kadeh',
    'kadın',
    'kadraj',
    'kafa',
    'kafkas',
    'kağıt',
    'kağnı',
    'kahkaha',
    'kahraman',
    'kahvaltı',
    'kakül',
    'kaldırım',
    'kale',
    'kalibre',
    'kalkan',
    'kalpak',
    'kamış',
    'kamyon',
    'kanat',
    'kandaş',
    'kanepe',
    'kanser',
    'kanun',
    'kaos',
    'kapı',
    'kaplıca',
    'kaptan',
    'karanlık',
    'kardeş',
    'karga',
    'karınca',
    'karmaşa',
    'karşıt',
    'kasırga',
    'kask',
    'kasvet',
    'katkı',
    'katman',
    'kavram',
    'kaygan',
    'kaynakça',
    'kayyum',
    'kedi',
    'kehanet',
    'kekik',
    'kelebek',
    'kenar',
    'kerkenez',
    'kerpiç',
    'kesirli',
    'kesmece',
    'kestane',
    'keşkek',
    'ketçap',
    'keyfiyet',
    'kıble',
    'kıdemli',
    'kılavuz',
    'kılçık',
    'kılıf',
    'kıraç',
    'kırmızı',
    'kırsal',
    'kısayol',
    'kısım',
    'kıskanç',
    'kısmet',
    'kışla',
    'kıvanç',
    'kıvılcım',
    'kıvrık',
    'kıyafet',
    'kıymetli',
    'kızak',
    'kızılcık',
    'kibar',
    'kinaye',
    'kira',
    'kiremit',
    'kirli',
    'kirpik',
    'kişisel',
    'kitap',
    'koçbaşı',
    'kodaman',
    'koğuş',
    'kokteyl',
    'kolaycı',
    'kolbastı',
    'kolonya',
    'koltuk',
    'kolye',
    'kombine',
    'komedyen',
    'komiser',
    'komposto',
    'komşu',
    'komuta',
    'konak',
    'konfor',
    'koni',
    'konsül',
    'kopya',
    'korkusuz',
    'korna',
    'korse',
    'korunak',
    'korvet',
    'kostüm',
    'koşul',
    'koyu',
    'kozmik',
    'köfte',
    'kökensel',
    'köprücük',
    'köpük',
    'kördüğüm',
    'körfez',
    'köstebek',
    'köşegen',
    'kötü',
    'kravat',
    'kriter',
    'kuantum',
    'kudurma',
    'kuluçka',
    'kulübe',
    'kumanya',
    'kumbara',
    'kumlu',
    'kumpir',
    'kumral',
    'kundura',
    'kupa',
    'kupkuru',
    'kuramsal',
    'kurbağa',
    'kurdele',
    'kurgu',
    'kurmay',
    'kurşun',
    'kurtuluş',
    'kurultay',
    'kurye',
    'kusursuz',
    'kuşak',
    'kuşbaşı',
    'kuşkulu',
    'kutlama',
    'kutsal',
    'kutup',
    'kuver',
    'kuyruk',
    'kuzey',
    'kuzgun',
    'küçük',
    'külçe',
    'külfet',
    'külliye',
    'kültürel',
    'kümes',
    'künefe',
    'küresel',
    'kütle',
    'lahana',
    'lahmacun',
    'lamba',
    'lansman',
    'lavaş',
    'layık',
    'leğen',
    'levent',
    'leziz',
    'lezzet',
    'lider',
    'likide',
    'liman',
    'liste',
    'litre',
    'liyakat',
    'lodos',
    'lokanta',
    'lokman',
    'lokum',
    'lunapark',
    'lütfen',
    'lüzum',
    'nokta',
    'mabet',
    'macera',
    'macun',
    'madalya',
    'madde',
    'madem',
    'mağara',
    'mağdur',
    'mağfiret',
    'mağlup',
    'mahalle',
    'mahcup',
    'mahir',
    'mahkeme',
    'mahlas',
    'mahrum',
    'mahsul',
    'makas',
    'makbuz',
    'makine',
    'makro',
    'maksat',
    'makul',
    'maliye',
    'manav',
    'mangal',
    'manidar',
    'manken',
    'mantık',
    'manzara',
    'mareşal',
    'margarin',
    'marifet',
    'market',
    'marmelat',
    'masaüstü',
    'masmavi',
    'masraf',
    'masum',
    'matah',
    'materyal',
    'matrak',
    'maval',
    'mavra',
    'maydanoz',
    'mayhoş',
    'maytap',
    'mazbata',
    'mazeret',
    'mazlum',
    'mazot',
    'mazur',
    'meblağ',
    'mebus',
    'mecaz',
    'mecbur',
    'meclis',
    'mecmua',
    'mecnun',
    'meçhul',
    'medeni',
    'mehtap',
    'mekanik',
    'melodi',
    'meltem',
    'memur',
    'mendil',
    'menekşe',
    'menteşe',
    'meraklı',
    'mercek',
    'merdiven',
    'merhaba',
    'merinos',
    'merkez',
    'mermi',
    'mert',
    'mesafe',
    'mesele',
    'mesken',
    'meslek',
    'meşale',
    'meşgul',
    'meşhur',
    'metafor',
    'metin',
    'metre',
    'mevcut',
    'mevkidaş',
    'meydan',
    'meyil',
    'meyve',
    'meziyet',
    'mezun',
    'mıknatıs',
    'mısra',
    'mızıka',
    'miğfer',
    'mihrak',
    'mikrofon',
    'miktar',
    'milat',
    'milli',
    'mimar',
    'minare',
    'mineral',
    'minik',
    'minyon',
    'mirliva',
    'misafir',
    'miskin',
    'miting',
    'miyop',
    'mizah',
    'mobilya',
    'model',
    'monitör',
    'morötesi',
    'motive',
    'motor',
    'mozaik',
    'muavin',
    'mucize',
    'muhafız',
    'muhteşem',
    'mukayese',
    'mumya',
    'musluk',
    'muşamba',
    'mutabık',
    'mutfak',
    'mutlu',
    'muzaffer',
    'muzdarip',
    'mübarek',
    'mücadele',
    'müdür',
    'müfredat',
    'müftü',
    'mühendis',
    'mühim',
    'mühlet',
    'mükemmel',
    'mülk',
    'mümkün',
    'mümtaz',
    'müsrif',
    'müstesna',
    'müşahit',
    'müşteri',
    'mütercim',
    'müthiş',
    'müze',
    'müzik',
    'nabız',
    'nadas',
    'nadir',
    'nahoş',
    'nakarat',
    'nakış',
    'nalbur',
    'namlu',
    'namus',
    'nankör',
    'nargile',
    'narkoz',
    'nasıl',
    'nasip',
    'naylon',
    'nazar',
    'nazım',
    'nazik',
    'neden',
    'nefes',
    'negatif',
    'neon',
    'neptün',
    'nerede',
    'nesil',
    'nesnel',
    'neşeli',
    'netice',
    'nevresim',
    'neyse',
    'neyzen',
    'nezaket',
    'nezih',
    'nezle',
    'nicel',
    'nilüfer',
    'nimet',
    'nisan',
    'nispet',
    'nitekim',
    'nizam',
    'nohut',
    'noksan',
    'normal',
    'nostalji',
    'noter',
    'nöbet',
    'numara',
    'numune',
    'nutuk',
    'nüfus',
    'obabaşı',
    'obez',
    'obje',
    'ocak',
    'odun',
    'ofansif',
    'ofis',
    'oğlak',
    'oğuz',
    'okçu',
    'oklava',
    'oksijen',
    'okul',
    'okumuş',
    'okutman',
    'okuyucu',
    'okyanus',
    'olağan',
    'olanak',
    'olası',
    'olay',
    'olgun',
    'olimpik',
    'olumlu',
    'omlet',
    'omurga',
    'onarım',
    'onursal',
    'opera',
    'optik',
    'oral',
    'orantı',
    'ordu',
    'organik',
    'orijin',
    'orkide',
    'orman',
    'orta',
    'oruç',
    'otağ',
    'otantik',
    'otel',
    'otoban',
    'otogar',
    'otomobil',
    'otonom',
    'otopark',
    'otorite',
    'otoyol',
    'oturum',
    'oyuk',
    'oyuncak',
    'ozan',
    'ödeme',
    'ödenek',
    'ödev',
    'ödül',
    'ödünç',
    'öfke',
    'öğlen',
    'öğrenci',
    'öğün',
    'öğütücü',
    'öksürük',
    'ölçme',
    'ölçü',
    'ölümsüz',
    'ömür',
    'önayak',
    'öncü',
    'önder',
    'önem',
    'önerge',
    'öngörü',
    'önlük',
    'önsezi',
    'öpücük',
    'ördek',
    'örgü',
    'örtbas',
    'örtme',
    'örtü',
    'örümcek',
    'örüntü',
    'öteberi',
    'öteki',
    'övünç',
    'öykü',
    'öyleyse',
    'özçekim',
    'özdeyiş',
    'özel',
    'özenti',
    'özerk',
    'özgürlük',
    'özlem',
    'özlü',
    'özne',
    'özsever',
    'özümseme',
    'özür',
    'özveri',
    'pabuç',
    'padişah',
    'palamut',
    'palmiye',
    'palto',
    'palyaço',
    'pamuk',
    'panayır',
    'pancar',
    'panda',
    'panel',
    'panik',
    'panjur',
    'pankart',
    'pano',
    'pansuman',
    'pantolon',
    'panzehir',
    'papatya',
    'papyon',
    'paraşüt',
    'parça',
    'pardösü',
    'parfüm',
    'parıltı',
    'parkur',
    'parmak',
    'parodi',
    'parsel',
    'partner',
    'pasaport',
    'pasif',
    'paskalya',
    'pastırma',
    'paşa',
    'patates',
    'paten',
    'patika',
    'patlıcan',
    'patolog',
    'patron',
    'payanda',
    'paydaş',
    'payidar',
    'paylaşma',
    'paytak',
    'peçete',
    'pedal',
    'peder',
    'pehlivan',
    'pekala',
    'pekmez',
    'pelerin',
    'pelikan',
    'pelüş',
    'pembe',
    'pena',
    'pencere',
    'pense',
    'perçin',
    'perde',
    'pergel',
    'perişan',
    'peron',
    'personel',
    'perşembe',
    'peruk',
    'pervane',
    'pespaye',
    'pestil',
    'peşin',
    'petek',
    'petrol',
    'petunya',
    'peynir',
    'peyzaj',
    'pınar',
    'pırasa',
    'pırlanta',
    'pide',
    'pikap',
    'piknik',
    'pilav',
    'piliç',
    'pilot',
    'pipet',
    'pipo',
    'piramit',
    'pirinç',
    'pirzola',
    'pist',
    'pişik',
    'pişman',
    'piyasa',
    'piyes',
    'plaj',
    'plaket',
    'planlama',
    'platform',
    'plazma',
    'podyum',
    'poğaça',
    'polat',
    'polen',
    'politika',
    'pompa',
    'popüler',
    'porselen',
    'portakal',
    'posa',
    'poster',
    'poşet',
    'poyraz',
    'pozitif',
    'pranga',
    'pratik',
    'prenses',
    'prim',
    'problem',
    'profil',
    'program',
    'proje',
    'protokol',
    'prova',
    'puan',
    'pudra',
    'pusula',
    'püre',
    'pürüz',
    'püstül',
    'püsür',
    'racon',
    'radar',
    'radikal',
    'radyo',
    'rafadan',
    'rafine',
    'rağbet',
    'rahat',
    'rahle',
    'rakam',
    'raket',
    'rakip',
    'rakun',
    'ralli',
    'rampa',
    'randevu',
    'ranza',
    'rapor',
    'rastgele',
    'rasyonel',
    'razı',
    'realite',
    'reçine',
    'refah',
    'referans',
    'refik',
    'reform',
    'rehber',
    'rehin',
    'reis',
    'rekabet',
    'reklam',
    'rekor',
    'rektör',
    'renk',
    'resim',
    'resmen',
    'restoran',
    'retorik',
    'revaç',
    'revize',
    'reyon',
    'rezalet',
    'rezerv',
    'rezil',
    'rıhtım',
    'rıza',
    'ritim',
    'ritüel',
    'rivayet',
    'robot',
    'roman',
    'rota',
    'rozet',
    'röportaj',
    'rötar',
    'ruble',
    'ruhban',
    'ruhsat',
    'rulet',
    'rulo',
    'runik',
    'rutin',
    'rutubet',
    'rüşvet',
    'rütbe',
    'rüya',
    'rüzgar',
    'sabah',
    'sabıka',
    'sabit',
    'sabun',
    'saçma',
    'sade',
    'sadık',
    'safahat',
    'safdil',
    'safkan',
    'sağanak',
    'sağduyu',
    'sağlam',
    'saha',
    'sahiden',
    'sahne',
    'sakal',
    'sakız',
    'sakin',
    'saklama',
    'saksağan',
    'salamura',
    'salça',
    'salgı',
    'salınım',
    'salkım',
    'salon',
    'saltanat',
    'sanatçı',
    'sancak',
    'sandalye',
    'saniye',
    'saplantı',
    'sapsız',
    'saray',
    'sarışın',
    'sarkık',
    'sarmaşık',
    'satır',
    'savaşım',
    'savunma',
    'saydam',
    'sayfa',
    'saygın',
    'sayısal',
    'sebep',
    'seçenek',
    'seçim',
    'seçkin',
    'seçmen',
    'seda',
    'sedir',
    'sedye',
    'sefer',
    'sehpa',
    'sekizgen',
    'selektör',
    'selvi',
    'semavi',
    'sembol',
    'seminer',
    'senaryo',
    'sendika',
    'senkron',
    'sensör',
    'sentez',
    'sepet',
    'seramik',
    'serbest',
    'serdar',
    'seremoni',
    'sergi',
    'serhat',
    'serin',
    'sermaye',
    'serpuş',
    'sersem',
    'serüven',
    'servis',
    'sesli',
    'sesteş',
    'sevap',
    'seviye',
    'seyahat',
    'seyirci',
    'sezon',
    'sıcak',
    'sıfat',
    'sıhhi',
    'sınanma',
    'sınır',
    'sıradan',
    'sırdaş',
    'sırma',
    'sırtüstü',
    'sızgıt',
    'siftah',
    'sigorta',
    'sihirbaz',
    'silah',
    'silecek',
    'silindir',
    'simetri',
    'simge',
    'simit',
    'sincap',
    'sindirim',
    'sinema',
    'sinirli',
    'sipariş',
    'sirke',
    'siroz',
    'sistem',
    'sivilce',
    'siyasi',
    'slogan',
    'soba',
    'sofra',
    'soğuk',
    'sohbet',
    'sokak',
    'solfej',
    'solunum',
    'somut',
    'sonbahar',
    'sonraki',
    'sonsuz',
    'sorunsuz',
    'sosyete',
    'soyağacı',
    'soydaş',
    'soygun',
    'soytarı',
    'söğüş',
    'sömürge',
    'sönük',
    'söylem',
    'sözcük',
    'sözde',
    'spatula',
    'spektrum',
    'spiker',
    'spiral',
    'sponsor',
    'sporcu',
    'sprey',
    'stabil',
    'statü',
    'stok',
    'stopaj',
    'strateji',
    'subay',
    'sucuk',
    'suçüstü',
    'suhulet',
    'sulama',
    'sungur',
    'sunucu',
    'surat',
    'susam',
    'suskun',
    'sükse',
    'sükut',
    'sülale',
    'sünger',
    'süpürge',
    'sürahi',
    'süreç',
    'sürgün',
    'sürüm',
    'süsleme',
    'sütanne',
    'sütlaç',
    'sütun',
    'süvari',
    'şahane',
    'şahbaz',
    'şahit',
    'şahsiyet',
    'şakıma',
    'şaklaban',
    'şakrak',
    'şamar',
    'şampiyon',
    'şanslı',
    'şantiye',
    'şapka',
    'şarkıcı',
    'şartname',
    'şaşırma',
    'şaşkın',
    'şatafat',
    'şayet',
    'şebeke',
    'şefkat',
    'şeftali',
    'şehir',
    'şehvet',
    'şeker',
    'şekil',
    'şelale',
    'şema',
    'şemsiye',
    'şerbet',
    'şeref',
    'şerit',
    'şımarık',
    'şıpıdık',
    'şifre',
    'şimdi',
    'şimşek',
    'şipşak',
    'şirin',
    'şişe',
    'şişirme',
    'şofben',
    'şöhret',
    'şölen',
    'şüphe',
    'tabaka',
    'tabela',
    'tabure',
    'tadilat',
    'taharet',
    'tahıl',
    'tahkim',
    'tahlil',
    'tahmin',
    'tahrifat',
    'tahsilat',
    'tahta',
    'taklit',
    'takoz',
    'taksici',
    'taktik',
    'takvim',
    'talebe',
    'talip',
    'tamamen',
    'tamirci',
    'tampon',
    'tamtakır',
    'tandır',
    'tanecik',
    'tanıtım',
    'tanrı',
    'tansiyon',
    'tapan',
    'tapınak',
    'taptaze',
    'tapu',
    'tarafgir',
    'tarhana',
    'tarım',
    'tarih',
    'tarla',
    'tartak',
    'tarumar',
    'tasarım',
    'tasdik',
    'taslak',
    'tastamam',
    'taşeron',
    'taşınmaz',
    'taşra',
    'tatava',
    'tatbikat',
    'tatil',
    'tatlı',
    'tavsiye',
    'tavşan',
    'tavuk',
    'taze',
    'taziye',
    'tazminat',
    'tebeşir',
    'tebrik',
    'tecrübe',
    'teçhizat',
    'tedarik',
    'tedbir',
    'teftiş',
    'teğet',
    'teğmen',
    'tehdit',
    'tehlike',
    'tekdüze',
    'tekerlek',
    'tekme',
    'teknik',
    'tekrar',
    'telef',
    'telsiz',
    'telve',
    'temas',
    'tembel',
    'temiz',
    'temkin',
    'tempo',
    'temsilci',
    'tendon',
    'teneke',
    'tenha',
    'tenkit',
    'tepegöz',
    'tepki',
    'terazi',
    'terbiye',
    'tercih',
    'tereyağı',
    'terfi',
    'terim',
    'terminal',
    'tersane',
    'tertip',
    'tesadüf',
    'tescil',
    'tesir',
    'teslimat',
    'tespit',
    'testere',
    'teşekkür',
    'teşhir',
    'teşrif',
    'teşvik',
    'teyze',
    'tezahür',
    'tezgah',
    'tıbbi',
    'tıkaç',
    'tıkışık',
    'tıknaz',
    'tılsım',
    'tıpkı',
    'tıraş',
    'tırışka',
    'tırmanış',
    'tırnak',
    'tırpan',
    'tıslama',
    'ticaret',
    'tilki',
    'tiryaki',
    'titreşim',
    'tohum',
    'tokat',
    'tolere',
    'tomar',
    'tombak',
    'tomurcuk',
    'topaç',
    'toplum',
    'toprak',
    'toptan',
    'toraman',
    'torpido',
    'tortu',
    'tosbağa',
    'toynak',
    'tören',
    'trafik',
    'trajedi',
    'tramvay',
    'transfer',
    'tribün',
    'triko',
    'tugay',
    'tuğla',
    'tuğrul',
    'tuhaf',
    'tulumba',
    'tunç',
    'turan',
    'turkuaz',
    'turnusol',
    'turşu',
    'turuncu',
    'tutanak',
    'tutkal',
    'tutsak',
    'tutum',
    'tuyuğ',
    'tuzlu',
    'tüccar',
    'tüfek',
    'tükenmez',
    'tülbent',
    'tümleç',
    'tünel',
    'türbin',
    'türev',
    'türk',
    'tüzük',
    'ucube',
    'ucuz',
    'uçak',
    'uçurtma',
    'ufuk',
    'uğrak',
    'uğur',
    'ukala',
    'ulaşım',
    'ulema',
    'ulus',
    'ulvi',
    'umursama',
    'umut',
    'unutkan',
    'uslu',
    'ustabaşı',
    'ustura',
    'usul',
    'utangaç',
    'uyanık',
    'uyarı',
    'uydu',
    'uygar',
    'uygulama',
    'uykusuz',
    'uysal',
    'uyuşma',
    'uzantı',
    'uzay',
    'uzgören',
    'uzlaşma',
    'uzman',
    'uzun',
    'ücra',
    'ücret',
    'üçbudak',
    'üçgen',
    'üçkağıt',
    'üçleme',
    'üfürük',
    'ülke',
    'ümit',
    'üniforma',
    'ünite',
    'ünlem',
    'üretken',
    'ürün',
    'üslup',
    'üstel',
    'üstün',
    'üşengeç',
    'üşüme',
    'ütopya',
    'üvey',
    'üzengi',
    'üzgün',
    'üzüm',
    'vagon',
    'vaka',
    'vakfiye',
    'vakıf',
    'vakit',
    'vakum',
    'vapur',
    'varil',
    'varlık',
    'varsayım',
    'varyemez',
    'vasıta',
    'vasiyet',
    'vatandaş',
    'vazife',
    'vazo',
    'veciz',
    'vefa',
    'vehim',
    'veliaht',
    'veresiye',
    'verimli',
    'verkaç',
    'vernik',
    'vertigo',
    'vesait',
    'vesika',
    'vestiyer',
    'veznedar',
    'vicdan',
    'vilayet',
    'virane',
    'virgül',
    'vişne',
    'vites',
    'vokal',
    'volkan',
    'vurma',
    'vurucu',
    'vücut',
    'yabancı',
    'yabgu',
    'yağış',
    'yağlı',
    'yağmur',
    'yakamoz',
    'yakın',
    'yaklaşık',
    'yalçın',
    'yalıtım',
    'yaman',
    'yanardağ',
    'yangın',
    'yanıt',
    'yankı',
    'yanlış',
    'yansıma',
    'yapay',
    'yapboz',
    'yapımcı',
    'yaprak',
    'yaratık',
    'yarbay',
    'yardım',
    'yargıç',
    'yarıçap',
    'yasemin',
    'yastık',
    'yaşam',
    'yatak',
    'yatırım',
    'yavru',
    'yaygara',
    'yayıncı',
    'yayla',
    'yazılım',
    'yekpare',
    'yekvücut',
    'yelkovan',
    'yelpaze',
    'yemek',
    'yemiş',
    'yengeç',
    'yeniçeri',
    'yeraltı',
    'yerküre',
    'yerleşke',
    'yeryüzü',
    'yeşil',
    'yetenek',
    'yetkili',
    'yığınak',
    'yıkama',
    'yılbaşı',
    'yıldırım',
    'yılkı',
    'yılmaz',
    'yırtıcı',
    'yiğit',
    'yoğurt',
    'yokuş',
    'yolcu',
    'yoldaş',
    'yolgeçen',
    'yolkesen',
    'yolüstü',
    'yordam',
    'yorgan',
    'yorumcu',
    'yosun',
    'yöndeş',
    'yönetim',
    'yönlü',
    'yöntem',
    'yöresel',
    'yörünge',
    'yufka',
    'yukarı',
    'yumruk',
    'yumurta',
    'yuvarlak',
    'yücelme',
    'yükçeker',
    'yüklem',
    'yüksek',
    'yürek',
    'yürütme',
    'yüzde',
    'yüzeysel',
    'yüzgeç',
    'yüzüstü',
    'yüzyıl',
    'zabıta',
    'zafer',
    'zahmet',
    'zambak',
    'zaptiye',
    'zarafet',
    'zaruret',
    'zeka',
    'zekice',
    'zemberek',
    'zemin',
    'zencefil',
    'zeplin',
    'zeytin',
    'zıbın',
    'zılgıt',
    'zımbırtı',
    'zımpara',
    'zıpkın',
    'zigon',
    'zihinsel',
    'zihniyet',
    'zincir',
    'zindan',
    'zirzop',
    'ziyaret',
    'ziynet',
    'zoraki',
    'zorlu',
    'zorunlu',
    'züğürt',
    'zümre'
];
//# sourceMappingURL=turkish.js.map